import { Button, Dialog } from "@/components/Elements";
import { SelectField } from "@/components/Form";
import { UserMap } from "@/components/Map";
import { getCountries, useCustomForm, useLocation } from "@/hooks";
import useToggle from "@/hooks/useToggle";
import { LatLngModel } from "@/types/common";
import { useEffect } from "react";
import * as z from "zod";

const locationMapSchema = z.object({
  countryCode: z.string().min(1, "Required"),
  country: z.string().optional(),
});

export type LocationMapSchemaModel = z.infer<typeof locationMapSchema>;

const countryList = getCountries();

function LocationMapView({
  location,
  radius,
}: {
  location: LatLngModel;
  radius: number;
}) {
  const { show: showModal, toggle: toggleModal } = useToggle();
  const { register, reset } = useCustomForm<LocationMapSchemaModel>({
    schema: locationMapSchema,
  });
  const { getAddressDetail } = useLocation();

  useEffect(() => {
    if (location)
      (async () => {
        const { countryCode, country } = await getAddressDetail(location);
        reset({ country, countryCode });
      })();
  }, [location]);

  return (
    <>
      <Button onClick={toggleModal} className="w-[49%]">
        Map View
      </Button>
      {showModal && (
        <Dialog isOpen={showModal} onClose={toggleModal}>
          <div className="flex-1">
            <SelectField
              registration={{
                ...register("countryCode"),
                disabled: true,
              }}
              className="text-[20px]"
              options={countryList}
            />
            <UserMap location={location} radius={radius} />
          </div>
        </Dialog>
      )}
    </>
  );
}

export default LocationMapView;
